// The info pane: the one shell for a panel of context beside or under the
// work (Browse's three panels, the Test Bed's accuracy box). A title, an
// optional subtitle, then the body; a loading line or an error in the body's
// place while it has nothing to show.
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function Pane({
  title,
  subtitle,
  loading,
  error,
  className,
  children,
}: {
  title: string;
  subtitle?: string | undefined;
  loading?: boolean | undefined;
  error?: string | null | undefined;
  className?: string | undefined;
  children: ReactNode;
}) {
  return (
    <section className={cn("rounded-lg border border-border bg-card p-4", className)} aria-label={title}>
      <header className="border-b border-border pb-2">
        <div className="text-sm font-medium">{title}</div>
        {subtitle && (
          <div className="mt-0.5 truncate text-xs text-muted-foreground" title={subtitle}>
            {subtitle}
          </div>
        )}
      </header>
      <div className="mt-3">
        {loading && <div className="text-sm text-muted-foreground">Loading…</div>}
        {error && (
          <div className="rounded-md border border-destructive bg-destructive/10 p-2 text-xs text-destructive">
            {error}
          </div>
        )}
        {!loading && !error && children}
      </div>
    </section>
  );
}
